<template>
<div id="footermap" class="p-max-wrap">
  <div class="p-max-1500">
    <div class="group"
      v-for="group in $t('footerMap')"
      :key="group.id">
      <div class="ft-16 ta" style="text-align: center;">{{ group.title }}</div>

      <ul class="list">
        <li v-for="item in group.list"
            :key="item.id">
          <a class="item ft-12 footer-map-col-link"
            :href="item.link" target="_blank">
            {{ item.title }}
          </a>
        </li>
      </ul>
    </div>

    <div class="group">
      <div class="footer-infos">
        <div class="footer-infos-top">
          <div class="footer-infos-logo">
            <img src="/images/66nord-logo.jpg">
          </div>
          <div class="footer-infos-address">
            <strong>{{$t('footGroup.name')}}</strong>
            <div class="footer-infos-address-text">
              {{$t('footGroup.add[0]')}}<br>
              {{$t('footGroup.add[1]')}}
            </div>
          </div>
        </div>
        <div class="footer-infos-middle ff-dr ft-30">
          +86-574-88847563
        </div>
        <div class="footer-infos-bottom">
          <div class="footer-infos-follow">Follow us!</div>
          <div class="footer-infos-socials">
            <a target="_blank"
              class="footer-infos-socials-item">
              <svg class="icon icon-facebook">
                <use xlink:href="#facebook"></use>
              </svg>
            </a>

            <a target="_blank"
              class="footer-infos-socials-item">
              <svg class="icon icon-insta">
                <use xlink:href="#insta"></use>
              </svg>
            </a>
            <a target="_blank"
              class="footer-infos-socials-item">
              <svg class="icon icon-youtube">
                <use xlink:href="#youtube"></use>
              </svg>
            </a>
            <a target="_blank"
              class="footer-infos-socials-item">
              <svg class="icon icon-cat_blog">
                <use xlink:href="#cat_blog"></use>
              </svg>
            </a>
          </div>
        </div>
      </div>

      <LangChoose @trigger-lang="triggerLang" />
    </div>
  </div>
</div>
</template>

<script>
import LangChoose from './LangChoose.vue'
export default {
  components: {
    LangChoose
  },

  methods: {
    triggerLang () {
      this.$emit('trigger-lang')
    }
  }
}
</script>

<style lang="scss" scoped>
#footermap .p-max-1500 {
  z-index: 1200;
  display: flex;
  justify-content: space-between;
}

.group {
  padding-top: 32px;
}

.list {
  padding-top: 16px;
}

.item {
  padding: 16px;
}

.footer-map-col-link {
  color: #242a3a;
  display: block;
  text-decoration: none;
  line-height: 26px;
  -webkit-transition: .5s cubic-bezier(.165,.84,.44,1);
  transition: .5s cubic-bezier(.165,.84,.44,1)
}

.footer-map-col-link:hover {
  cursor: pointer !important;
  color: #96daf0;
}

.footer-infos {
  border: 1px solid #242a3a;
}

.footer-infos-top {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 115px;
  border-bottom: 1px solid #242a3a;
  display: block;
}

.footer-infos-middle {
  padding: 4px 8px 0 8px;
  text-align: center;
  border-bottom: 1px solid #242a3a;
  font-size: 25px;
}

.footer-infos-bottom {
  display: block;
  text-align: center;
  height: 60px;
  font-size: 0
}

.footer-infos-logo {
  width: 115px;
  height: 115px;
  display: inline-block;
  text-align: center;
  border-right: 1px solid #242a3a;
  position: relative;
  vertical-align: middle
}

.footer-infos-logo img {
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 51%;
  margin-left: -47px;
  margin-top: -43px
}

.footer-infos-address {
  display: inline-block;
  vertical-align: middle;
  font-size: 12px;
  line-height: 14px;
  color: #242a3a;
  padding-left: 30px;
  padding-right: 30px;

  .footer-infos-address-text {
    line-height: 24px;
  }
}

.footer-infos-address span {
  display: block
}

.footer-infos-address strong {
  display: block;
  font-family: geomanistbold,Sans-Serif;
  font-size: 16px;
  margin-bottom: 12px;
}

.footer-infos-follow {
  font-size: 14px;
  font-family: geomanistbold,Sans-Serif;
  color: #242a3a;
  text-align: center;
  width: 40%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  vertical-align: middle;
  display: inline-block;
  line-height: 60px
}

.footer-infos-socials {
  padding: 0 10px;
  line-height: 0;
  white-space: nowrap;
  width: 60%;
  display: inline-block;
  vertical-align: middle;
  -webkit-box-sizing: border-box;
  box-sizing: border-box
}

.footer-infos-socials-item {
  display: inline-block;
  padding: 8px 8px
}

.footer-infos-socials-item:hover .icon {
  fill: #96daf0
}

.footer-infos-socials-item .icon {
  width: 20px;
  height: 20px;
  fill: #242a3a;
  -webkit-transition: fill .5s cubic-bezier(.165,.84,.44,1);
  transition: fill .5s cubic-bezier(.165,.84,.44,1)
}

.footer-bottom {
  height: 80px;
  background-color: #242a3a;
  text-align: center;
  position: relative;
  z-index: 1100;
}

.footer-bottom-link {
  display: inline-block;
  line-height: 80px;
  color: #fff;
  font-size: 12px;
  text-decoration: none;
  padding: 0 8px;
  -webkit-transition: color .5s cubic-bezier(.165,.84,.44,1);
  transition: color .5s cubic-bezier(.165,.84,.44,1)
}

.footer-bottom-link:hover {
  color: #96daf0
}
@media(max-width: 1366px){
  .footer-infos-top{
    display: flex;
    flex-direction: row;
  }
  .footer-infos-logo img{
    left:50%;
    margin-left: -40px;
    z-index: -1;
  }
  .footer-infos-address-text{
    line-height: 16px !important;
  }
}
@media(max-width: 1366px){
  .ta{
    font-size: 14px;
  }
  .footer-map-col-link{
    font-size: 12px;
    text-align: center;
  }
  .item{
    padding: 8px;
  }
}
@media(max-width: 768px){
  #footermap{
    display: none;
  }
}
</style>
